export default [
  {
    formFields: [
      {
        title: 'Video File',
        type: 'uploadcare',
        property: 'file_id',
        value: '',
        options: {
          ucClasses: 'sr-uc-restrict-video'
        }
      },
      {
        title: 'Video name',
        type: 'text',
        property: 'title',
        value: '',
        counter: 150,
        rules: [(v) => !!v || 'Video name is required', (v) => v.length <= 150 || 'Video name must be 150 characters or less'],
        required: true
      },
      {
        title: 'Video description',
        type: 'textarea',
        property: 'description',
        value: '',
        counter: 400,
        rules: [(v) => v.length <= 400 || 'Description must be 400 characters or less']
      }
    ]
  }
];
